import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class ChecklistService {
  getallChecklist(data) {
    return axios.get(serverURL + "/checklist-api?req=smarttableChecklist", {
      params: data,
      headers: headeroption,
    })
  }
  getChecklist(checklist_id) {
    return axios.get(serverURL + "/checklist-api?req=getChecklist", {
      params: { checklist_id: checklist_id }, headers: headeroption,
    });
  }
  createChecklist(data) {
    return axios.post(serverURL + "/checklist-api?req=createChecklist", data, {
      headers: headeroption,
    });
  }
  updateChecklist(data) {
    return axios.put(serverURL + "/checklist-api?req=updateChecklist", data, {
      headers: headeroption,
    });
  }
  deleteChecklist(checklist_id) {
    return axios.delete(serverURL + "/checklist-api?req=deleteChecklist", { params: { checklist_id: checklist_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/checklist-api?req=deleteChecklist");
  }
  findByTitle(checklist_name) {
    return axios.get(serverURL + "/checklist/checklist-api?name=" + checklist_name);
  }
  upload(checklist_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?checklist_id=" + checklist_id, data, { headers: headeroptionupload });
  }
  uploads(checklist_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?checklist_id=" + checklist_id, data, { headers: headeroptionupload });
  }
}
export default new ChecklistService();
